import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

type AddressType = {
  fullName: string;
  address: string;
  zipCode: string;
  city: string;
  state: string;
  country: { label: string; value: string } | string | null;
};

const initialState: AddressType | null = null;

export const addressStateSlice = createSlice({
  name: 'addressStateSlice',
  initialState,
  reducers: {
    setAddressData: (state, action) => {
      state = { ...action.payload };
      return state;
    },
    resetAddressData: () => {
      return initialState;
    }
  }
});

export const { setAddressData, resetAddressData } = addressStateSlice.actions;
export const getAddressData = (state: RootState) => state.addressStateSlice;
